// src/store/slices/auth/selectors.ts
import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

// Base selector
export const selectAuth = (state: RootState) => state.auth;

// Simple selectors (no need for memoization)
export const selectAuthError       = createSelector(selectAuth, authState => authState.error);
export const selectTwoFactorMethod = createSelector(selectAuth, authState => authState.twoFactorMethod);
export const selectTwoFactorToken  = createSelector(selectAuth, authState => authState.twoFactorToken);
export const selectSessionToken = createSelector(selectAuth, authState => {
  const { sessionToken } = authState;
  return typeof sessionToken === 'string' ? sessionToken : undefined;
});

// Derived / computed selectors (memoized)
export const selectAuthStatus      = createSelector(selectAuth, authState => authState.status);
export const selectIsLoggedIn      = createSelector(selectAuth, authState => authState.status === 'authenticated');

// Field-level error selector (factory)
export const selectFieldError = (field: string) =>
  createSelector(selectAuth, s => s.fieldErrors[field]);
export const selectFieldErrors = createSelector(selectAuth, authState => authState.fieldErrors);

export const selectTwoFactorMaskedDestination = createSelector(selectAuth, authState => authState.twoFactorMaskedDestination);
export const selectMaskedEmail = createSelector(selectAuth, auth => auth.maskedEmail);

export const selectMaskedPhone = createSelector(selectAuth, auth => auth.maskedPhone);

export const selectForgotPasswordEmailAddress = createSelector(selectAuth, auth => auth.forgotPasswordEmailAddress);
export const selectRecoveryToken = createSelector(selectAuth, auth => auth.recoveryToken);
export const selectRecoveryMaskedPhone = createSelector(selectAuth, auth => auth.recoveryMaskedPhone);
